// Derived from published_at: PUBLISHED when it is set, DRAFT when it is null.
export var AdminNoticeStatus;
(function (AdminNoticeStatus) {
    AdminNoticeStatus["PUBLISHED"] = "PUBLISHED";
    AdminNoticeStatus["DRAFT"] = "DRAFT";
})(AdminNoticeStatus || (AdminNoticeStatus = {}));
